<template>
  <v-container fluid>
    <v-layout wrap class="pos-rel pb-4">
      <v-flex xs12>
        <FilesList />
      </v-flex>
      <div class="files_loader">
        <div class="text-xs-center" v-if="this.busy">
          <v-progress-circular
            :size="24"
            :width="3"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import FilesList from '../components/Files/FilesList.vue';

export default {
  name: 'files',
  components: {
    FilesList,
  },
  data: () => ({
    busy: false,
  }),
  computed: {
    ...mapGetters('files', [
      'filesList',
      'totalPages',
      'query',
      'currentPage',
    ]),
    singleParams() {
      const { params } = this.$route;
      return {
        client_id: params.clientId,
      };
    },
    canGetPage() {
      const isLastPage = this.totalPages === this.currentPage;
      return !this.busy && this.filesList && this.filesList.length !== 0 && !isLastPage;
    },
  },
  methods: {
    ...mapActions('files', [
      'getSearchList',
      'setQuery',
      'clearSelectedFiles',
      'getSearchPage',
      'setCurrentPage',
    ]),
    getList() {
      const { query } = this.$route;
      let tags = query.tags_id;
      if (typeof tags === 'string') {
        tags = [parseInt(tags, 0)];
        query.tags_id = tags;
      }
      this.setQuery(query);
      this.getSearchList(this.singleParams);
    },
    async getPage() {
      if (this.canGetPage) {
        this.busy = true;
        const nextPage = this.currentPage + 1;
        this.setCurrentPage(nextPage);
        await this.getSearchPage(this.singleParams);
        this.busy = false;
      }
    },
    infinityScroll() {
      window.onscroll = () => {
        if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
          this.getPage();
        }
      };
    },
  },
  beforeDestroy() {
    this.setQuery(null);
  },
  mounted() {
    this.getList();
    this.infinityScroll();
  },
  watch: {
    $route() {
      this.getList();
      this.clearSelectedFiles();
    },
  },
};
</script>
